// extracted by mini-css-extract-plugin
module.exports = {"dropdownButton":"ControlPanel_dropdownButton__1o6TV","dropdownScroll":"ControlPanel_dropdownScroll__17rgQ","link":"ControlPanel_link__OEqVs"};